import React, { useState, useEffect } from "react";
import "./trackCorporate.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Modal, Button } from "react-bootstrap";
import { ThreeCircles } from "react-loader-spinner";
import moment from "moment";
import AdminTabs from "../adminTabs";
import GetAPI from "../../APICalls/GetAPI";
import PutAPI from "../../APICalls/PutAPI";

const TrackCorporate = () => {
  // State to manage active tabs for today/tomorrow
  const environment = process.env.REACT_APP_NODE_ENV;
  const corporateAPI =
    environment === "PRODUCTION" || environment === undefined
      ? process.env.REACT_APP_PROD_CORPORATEORDER
      : process.env.REACT_APP_DEV_CORPORATEORDER;

  const [ordersData, setOrdersData] = useState({});
  const [activeDayTab, setActiveDayTab] = useState("today");
  const [activeSubTab, setActiveSubTab] = useState("accepted");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [craverData, setCraverData] = useState(null);
  const today = moment().format("YYYY-MM-DD");
  const tomorrow = moment().add(1, "day").format("YYYY-MM-DD");

  useEffect(() => {
    const getCorporateOrders = () => {
      setLoading(true);
      const completeDetailsURL = `${corporateAPI}?type=CORPORATE_ORDERS`;
      GetAPI(completeDetailsURL)
        .then((res) => {
          if (res.data.statusCode === 200) {
            setOrdersData(res.data.body);
          } else {
            console.log("Error occurred. Error =", res);
            alert("Failed to get chef details. Try again!!!");
          }
          setLoading(false);
        })
        .catch((e) => {
          console.log("Error occurred. Error =", e);
          alert("Failed to get chef details. Try again!!!");
          setLoading(false);
        });
    };
    getCorporateOrders();
  }, []);

  // Function to change tabs
  const handleTabChange = (dayTab, subTab) => {
    setActiveDayTab(dayTab);
    setActiveSubTab(subTab);
  };

  // Render the content based on the active sub-tab
  const renderContent = () => {
    const dateKey = activeDayTab === "today" ? today : tomorrow;
    const orders = {
      accepted: ordersData[dateKey]?.ACCEPTED || [],
      ready: ordersData[dateKey]?.["READY TO PICK"] || [],
      delivered: ordersData[dateKey]?.DELIVERED || [],
    };

    return renderOrders(orders[activeSubTab]);
  };

  useEffect(() => {
    if (craverData && craverData.length > 0) {
      setShowModal(true);
    }
  }, [craverData]);

  const renderOrders = (orders) => {
    const handleCraverListClick = async (order) => {
      const completeURL =
        corporateAPI +
        "?uuID=" +
        order?.uuID +
        "&deliveryDate=" +
        order?.deliveryDate;
      GetAPI(completeURL)
        .then((res) => {
          if (res.data.statusCode === 200) {
            setCraverData(res.data.body);
          } else {
            alert("Failed to get cravers data");
            console.log(res);
          }
        })
        .catch((e) => {
          console.log(e);
          alert("Failed to get cravers data");
        });
    };

    const handleModalClose = () => {
      setShowModal(false);
    };

    return orders.length ? (
      <div id="accordionExample" className="accordion">
        {orders.map((order) => {
          return (
            <div className="card" key={order.uuID}>
              <div className="card-header" id={`heading-${order.uuID}`}>
                <h2 className="mb-0">
                  <button
                    className="btn btn-block text-left collapsed"
                    type="button"
                    data-toggle="collapse"
                    data-target={`#collapse-${order.uuID}`}
                    aria-expanded="false"
                    aria-controls={`collapse-${order.uuID}`}
                  >
                    <ul className="list-group">
                      <li className="company-info">
                        <div className="ms-2 me-auto">
                          <div className="fw-bold">
                            Company Name - {order.companyName}
                          </div>
                        </div>
                        <span className="badge bg-warning text-dark rounded-pill my-2">
                          {order.deliverBy}
                        </span>
                      </li>
                      <li className="list-group-item d-flex justify-content-between align-items-start">
                        <div className="ms-2 me-auto">
                          <div className="fw-bold">Meal Name</div>
                          {order.orderedItems[0].menuName} *{" "}
                          {order.orderedItems[0].quantity}
                        </div>
                      </li>
                    </ul>
                  </button>
                </h2>
              </div>
              <div
                id={`collapse-${order.uuID}`}
                className="collapse"
                aria-labelledby={`heading-${order.uuID}`}
                data-parent="#accordionExample"
              >
                <Modal show={showModal} onHide={handleModalClose}>
                  <Modal.Header closeButton>
                    <Modal.Title>Craver List</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {craverData && (
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Craver Name</th>
                            <th>Quantity</th>
                            <th>Craver Mobile</th>
                          </tr>
                        </thead>
                        <tbody>
                          {craverData.map((craver, index) => (
                            <tr key={craver.id}>
                              <td>{index + 1}</td>
                              <td>{craver.craverName}</td>
                              <td>{craver.quantity}</td>
                              <td>{craver.craverMobile}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button onClick={handleModalClose}>Close</Button>
                  </Modal.Footer>
                </Modal>
                <div className="company-info m-2">
                  <ul>
                    <li className="list-group-item">
                      <button
                        className="btn btn-warning btn-block flex-fill btn-sm text-black"
                        onClick={() => handleCraverListClick(order)}
                      >
                        See Cravers List
                      </button>
                    </li>
                  </ul>

                  {order.status.toUpperCase() !== "DELIVERED" ? (
                    <div className="d-flex justify-content-between">
                      <button
                        className="btn btn-success flex-fill btn-sm text-white"
                        onClick={() => handleStatusChange(order)}
                      >
                        {order.status.toUpperCase() === "ACCEPTED"
                          ? "Move to Ready to Pick"
                          : "Move to Delivered"}
                      </button>
                    </div>
                  ) : null}
                </div>

                <div className="card-body">
                  <h5>Order Details</h5>
                  <ul className="list-group">
                    <li className="list-group-item">
                      <strong>Craver Name:</strong> {order.craverName}
                    </li>

                    <li className="list-group-item">
                      <strong>Items Type:</strong> {order.itemsType}
                    </li>
                    <li className="list-group-item">
                      <strong>Client ID:</strong> {order.clientID}
                    </li>

                    <li className="list-group-item">
                      <strong>Menu ID:</strong> {order.menuID}
                    </li>

                    <li className="list-group-item">
                      <strong>Ordered Items:</strong>
                      <ul>
                        {order.orderedItems.map((item) => (
                          <li key={item.menuID}>
                            <strong>Menu Name:</strong> {item.menuName}
                            <br />
                            <strong>Menu Price:</strong> {item.menuPrice}
                            <br />
                            <strong>Chef Price:</strong> {item.chefPrice}
                            <br />
                            <strong>Item Type:</strong> {item.itemType}
                            <br />
                            <strong>Quantity:</strong> {item.quantity}
                            <br />
                            <strong>Description:</strong> {item.description}
                          </li>
                        ))}
                      </ul>
                    </li>

                    <li className="list-group-item">
                      <strong>Chef ID:</strong> {order.chefID}
                    </li>

                    <li className="list-group-item">
                      <strong>Quantity:</strong> {order.quantity}
                    </li>

                    <li className="list-group-item">
                      <strong>Delivery Date:</strong> {order.deliveryDate}
                    </li>
                    <li className="list-group-item">
                      <strong>Total Amount:</strong> {order.totalAmount}
                    </li>
                    <li className="list-group-item">
                      <strong>Rating:</strong> {order.rating}
                    </li>

                    <li className="list-group-item">
                      <strong>Order ID:</strong> {order.orderID}
                    </li>

                    <li className="list-group-item">
                      <strong>Craver Mobile:</strong> {order.craverMobile}
                    </li>
                    <li className="list-group-item">
                      <strong>Cuisine:</strong> {order.cuisine}
                    </li>
                    <li className="list-group-item">
                      <strong>Craver Details:</strong>
                      <ul>
                        <li>
                          <strong>Craver Landmark:</strong>{" "}
                          {order.craverDetails.craverLandmark}
                        </li>
                        <li>
                          <strong>Craver Mobile:</strong>{" "}
                          {order.craverDetails.craverMobile}
                        </li>
                        <li>
                          <strong>Craver Address Coordinates:</strong>
                          <ul>
                            <li>
                              <strong>Latitude:</strong>{" "}
                              {order.craverDetails.craverAddressCoordinates.lat}
                            </li>
                            <li>
                              <strong>Longitude:</strong>{" "}
                              {order.craverDetails.craverAddressCoordinates.lng}
                            </li>
                          </ul>
                        </li>
                        <li>
                          <strong>Craver Apartment Name:</strong>{" "}
                          {order.craverDetails.craverApartmentName}
                        </li>
                        <li>
                          <strong>Craver Name:</strong>{" "}
                          {order.craverDetails.craverName}
                        </li>
                        <li>
                          <strong>Craver Address:</strong>{" "}
                          {order.craverDetails.craverAddress}
                        </li>
                        <li>
                          <strong>Craver House No:</strong>{" "}
                          {order.craverDetails.craverHouseNo}
                        </li>
                      </ul>
                    </li>

                    <li className="list-group-item">
                      <strong>Cost:</strong>
                      <ul>
                        <li>
                          <strong>Delivery Charge:</strong>{" "}
                          {order.cost.deliveryCharge}
                        </li>
                        <li>
                          <strong>GST:</strong> {order.cost.gst}
                        </li>

                        <li>
                          <strong>Food Charge:</strong> {order.cost.foodCharge}
                        </li>
                        <li>
                          <strong>Payable Amount:</strong>{" "}
                          {order.cost.payableAmount}
                        </li>
                        <li>
                          <strong>Total:</strong> {order.cost.total}
                        </li>
                        <li>
                          <strong>Delivery GST:</strong>{" "}
                          {order.cost.deliveryGst}
                        </li>

                        <li>
                          <strong>Item GST:</strong> {order.cost.itemGst}
                        </li>

                        <li>
                          <strong>Chef Charge:</strong> {order.cost.chefCharge}
                        </li>
                      </ul>
                    </li>
                    <li className="list-group-item">
                      <strong>Order Type:</strong> {order.orderType}
                    </li>
                    <li className="list-group-item">
                      <strong>Ordered Date:</strong> {order.orderedDate}
                    </li>
                    <li className="list-group-item">
                      <strong>UUID:</strong> {order.uuID}
                    </li>
                    <li className="list-group-item">
                      <strong>Comment:</strong> {order.comment}
                    </li>
                    <li className="list-group-item">
                      <strong>Chef Details:</strong>
                      <ul>
                        <li>
                          <strong>Chef Address:</strong>{" "}
                          {order.chefDetails.chefAddress}
                        </li>
                        <li>
                          <strong>Apartement Name:</strong>{" "}
                          {order.chefDetails.apartmentName}
                        </li>
                        <li>
                          <strong>Chef Name:</strong>{" "}
                          {order.chefDetails.chefName}
                        </li>
                        <li>
                          <strong>House No:</strong> {order.chefDetails.houseNo}
                        </li>
                        <li>
                          <strong>Chef Mobile:</strong>{" "}
                          {order.chefDetails.chefMobile}
                        </li>
                        <li>
                          <strong>Chef Address Coordinates:</strong>
                          <ul>
                            <li>
                              <strong>Latitude:</strong>{" "}
                              {order.chefDetails.chefAddressCoordinates.lat}
                            </li>
                            <li>
                              <strong>Longitude:</strong>{" "}
                              {order.chefDetails.chefAddressCoordinates.lng}
                            </li>
                          </ul>
                        </li>
                        <li>
                          <strong>Kitchen Name:</strong>{" "}
                          {order.chefDetails.kitchenName}
                        </li>
                        <li>
                          <strong>Directions to Reach:</strong>{" "}
                          {order.chefDetails.directionsToReach}
                        </li>
                      </ul>
                    </li>
                    <li className="list-group-item">
                      <strong>Menu Type:</strong> {order.menuType}
                    </li>

                    <li className="list-group-item">
                      <strong>Craver ID:</strong> {order.craverID}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    ) : (
      <p className="text-center">No Orders Available</p>
    );
  };

  const handleStatusChange = (order) => {
    setLoading(true);
    if (order.status.toUpperCase() === "ACCEPTED") {
      order.status = "READY TO PICK";
      order.type = "RTPBOOKDAAS";
    } else {
      order.status = "DELIVERED";
    }

    PutAPI(corporateAPI, order)
      .then((res) => {
        if (res.data.statusCode === 200 || res.data.statusCode === 201) {
          alert("Successfully updated!!!");
          window.location.reload();
        } else {
          alert("Failed to update!!!");
        }
        setLoading(false);
      })
      .catch((e) => {
        console.error(e);
        alert("Failed to update!!!");
        setLoading(false);
      });
  };

  return (
    <div>
      <AdminTabs />
      <div className="container">
        {/* Main Day Tabs (Today, Tomorrow) */}
        <ul className="nav nav-tabs justify-content-center trackCorporate">
          {["today", "tomorrow"].map((day, index) => (
            <li className="nav-item" key={day}>
              <a
                className={`nav-link ${activeDayTab === day ? "active" : ""}`}
                style={{
                  backgroundColor: activeDayTab === day ? "#2d2d56" : "",
                  color: activeDayTab === day ? "white" : "",
                }}
                onClick={() => handleTabChange(day, "accepted")}
              >
                {day.charAt(0).toUpperCase() + day.slice(1)} Count{" "}
                {ordersData[day === "today" ? today : tomorrow]?.ORDERCOUNT ||
                  0}
              </a>
            </li>
          ))}
        </ul>

        {/* Sub Tabs (Accepted, Ready To Pick, Delivered) */}
        <ul className="nav nav-pills mt-3 justify-content-center">
          {["accepted", "ready", "delivered"].map((subTab) => (
            <li className="nav-item" key={subTab}>
              <a
                className={`nav-link ${
                  activeSubTab === subTab ? "active" : ""
                }`}
                style={{
                  backgroundColor: activeSubTab === subTab ? "#2d2d56" : "",
                  color: activeSubTab === subTab ? "white" : "",
                }}
                onClick={() => handleTabChange(activeDayTab, subTab)}
              >
                {subTab.charAt(0).toUpperCase() + subTab.slice(1)}
              </a>
            </li>
          ))}
        </ul>

        {/* Content Area */}
        <div className="tab-content mt-4">
          {loading ? (
            <div className="d-flex justify-content-center">
              <ThreeCircles
                height="100"
                width="100"
                color="#4fa94d"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="three-circles-rotating"
                outerCircleColor=""
                innerCircleColor=""
                middleCircleColor=""
              />
            </div>
          ) : (
            <div className="row justify-content-center">{renderContent()}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrackCorporate;
